import moment from 'moment';
import { date_utils } from '../common/date_utils';
import { DaySchedule, DaySlot } from '../common/timespan/day.schedule';
import { TimeAtom } from '../common/timespan/time_utils';
import {
  TAccessLog,
  TAgent,
  TBookingBase,
  TDevice,
  TLocationBase,
  TLockerBase,
  TLockerCellBase,
  TMemberBase,
  TSpaceBase,
  TUserBase,
} from '../thinkdesks/thinkdesks.entities';
export enum TUserType {
  'sysadmin' = 'sysadmin',
  'admin' = 'admin',
  'user' = 'user',
  'cms' = 'cms',
}
export function isSysAdmin(user: TUser) {
  return user.userType == TUserType.sysadmin;
}
export function isAdmin(user: TUser) {
  return (
    user.userType == TUserType.admin || user.userType == TUserType.sysadmin
  );
}

function bufferToHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}
export async function inviteLink(lang: string, object: TBooking) {


  const encoder = new TextEncoder();
  const data = encoder.encode(`${object.id}-${object.uuid}`);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  let hash = bufferToHex(hashBuffer);

  let url = `${location.origin}/${lang}/invite/${object.id}-${hash}`;
  return url;
}
export enum TMemberBlacklistRecordType {
  'blacklist' = 'blacklist',
  'release' = 'release',
}
export class TMemberBlacklistRecord {
  id: number;

  member: TMember;

  date: moment.Moment;
  blacklistReason: string;

  type: TMemberBlacklistRecordType;
}

export class TUser extends TUserBase {
  userType: TUserType;
  organizations: TOrganization[];
  locale: string;
}

export class TOrganization {
  id: number;
  active: boolean;
  name: string;
  name_lang: any;
  numSpaces: number;
  numLocations: number;
  locations: TLocation[];
}

export class TClientAccessLog {
  time: moment.Moment;
  member: TMember;
  deviceId: number;
  admin: boolean;
}
export class TAccount {
  id: number;
  name: string;
  gateCode: number;
}

export class TLocation extends TLocationBase {
  organization: TOrganization;
  terms: string;
  terms_lang: any;

  facilities: TSpaceFacility[];
}

export class TAgentContent {
  id: number;
  ext: string;
  active: boolean;
  filename: string;
}
export class TSpaceType {
  id: number;
  name: string;
  name_lang: any;
}
export class TSpacePurpose {
  id: number;
  name: string;
  name_lang: any;
}

export enum SpaceFacilityFee {
  'free' = 'free',
  'fee' = 'fee',
  'custom' = 'custom',
}

export class TSpaceFacility {
  id: number;
  name: string;
  name_lang: any;
  fee: SpaceFacilityFee;
  feeText: string;
  images: string[];
}
export class TLockerCell extends TLockerCellBase { }

export class TLocker extends TLockerBase { }

export class TMemberWishlist {
  id: number;
  date: moment.Moment;
  space: TSpace;
}
export class TSpace extends TSpaceBase {
  bookingMode: boolean;
  staffOnly: boolean
  types: TSpaceType[];
  facilities: TSpaceFacility[];
  terms: string;
  terms_lang: any;
  createTime: moment.Moment;
}

export class TEvent {
  id: number;
  name: string;
  space: TSpace;
  startTime: moment.Moment;
  endTime: moment.Moment;
}

export class TMemberType {
  id: number;
  name: string;
  code: string;
  permissions: string[];
}
export class TMember extends TMemberBase {
  memberType: TMemberType;
  memberTier: string;
  permissions: string[];
  locations: TLocation[];
  userId: string;
}

export class TMemberGroup {
  id: number;
  name: string;
}

export class TCheckinLog {
  id: number;

  time: moment.Moment;
  member: TMember;
  booking: TBooking;
  deviceId: number;
  deviceName: string;
}

export enum BookingCancelReason {
  'event_cancelled' = 'event_cancelled',
  'incorrect_booking' = 'incorrect_booking',
  'unexpected_matter' = 'unexpected_matter',
  'other_location' = 'other_location',
  'other' = 'other',
}

export class TBookingParticipant {
  date: moment.Moment
  member: TMember;
  walkin: boolean;
  log: TCheckinLog;
}
export class TBooking extends TBookingBase {
  numParticipants: number;
  facilities: TSpaceFacility[];
  facilityInfo: any;
  purpose: TSpacePurpose;
  checkinLogs: TCheckinLog[];
  checkin: TCheckinLog;
  rejectMember: TMember;
  cancelMember: TMember;
  approveMember: TMember;
  uuid: string;
  participants: TBookingParticipant[]
  walkins: TBookingParticipant[] = [];
}

export class TLockerBooking {
  id: number;
  user: TUser;
  locker: TLocker;
  startTime: moment.Moment;
  endTime: moment.Moment;

  schedule: DaySchedule;
}

export class AccessUtils {
  static fixClientAccessLog(o: TClientAccessLog) {
    o.time = date_utils.toMomentLocal(o.time);
  }
  static fixMemberGroup(o: TMemberGroup) { }
  static fixMemberType(o: TMemberType) {
    o.permissions = o.permissions ?? [];
  }
  static fixMember(o: TMember) {

    o.createTime = date_utils.toMomentLocal(o.createTime);
    o.updateTime = date_utils.toMomentLocal(o.updateTime);
    o.lastLogin = date_utils.toMomentLocal(o.lastLogin);
    o.blacklistTime = date_utils.toMomentLocal(o.blacklistTime);
    o.blacklistReleaseTime = date_utils.toMomentLocal(o.blacklistReleaseTime);
  }

  ////////////
  ////////////
  ////////////
  ////////////
  ////////////
  static fixLocation(o: TLocation) {
    o.name_lang = this.lang(o.name_lang);
    o.description_lang = this.lang(o.description_lang);
    o.address_lang = this.lang(o.address_lang);
    o.openingHours_lang = this.lang(o.openingHours_lang);
    o.contactPerson_lang = this.lang(o.contactPerson_lang);
    o.terms_lang = this.lang(o.terms_lang);
    o.createTime = date_utils.toMomentLocal(o.createTime);
    o.images = o.images ?? [];
    if (o.spaces) {
      for (let s of o.spaces) this.fixSpace(s as any);
    }
    if (o.organization) {
      this.fixOrganization(o.organization);
    }
    o.facilities = o.facilities ?? [];
    for (let f of o.facilities) {
      this.fixSpaceFacility(f);
    }
  }
  static fixLocker(o: TLocker) {
    o.images = o.images ?? [];
  }
  static fixWishlist(o: TMemberWishlist) {
    o.date = date_utils.toMomentLocal(o.date);
    if (o.space) {
      this.fixSpace(o.space);
    }
  }
  static fixSpace(o: TSpace) {
    o.name_lang = this.lang(o.name_lang);
    o.description_lang = this.lang(o.description_lang);
    o.remarks_lang = this.lang(o.remarks_lang);
    o.textDescription_lang = this.lang(o.textDescription_lang);
    o.includedFacilities_lang = this.lang(o.includedFacilities_lang);
    o.terms_lang = this.lang(o.terms_lang);
    o.createTime = date_utils.toMomentLocal(o.createTime);
    if (o.location) {
      this.fixLocation(o.location as any);
    }
    o.types = o.types ?? [];
    for (let t of o.types) {
      this.fixSpaceType(t);
    }
    o.facilities = o.facilities ?? [];
    for (let t of o.facilities) {
      this.fixSpaceFacility(t);
    }
    // if (typeof o.type == 'number') {
    //   o.type = cache.spaceTypes.find((c) => c.id == (o.type as any));
    // }
    // o.facilities = o.facilities ?? [];
    // for (let i = 1; i <= 10; i++) {
    //   let id = o[`facility${i}`];
    //   if (id) {
    //     let f = cache.spaceFacilities.find((c) => c.id == id);
    //     if (f) o.facilities.push(f);
    //   }
    // }
    o.images = o.images ?? [];
  }
  static lang(o: any) {
    if (!o) return {};
    if (typeof o == 'string') {
      return JSON.parse(o);
    }
    return o;
  }
  static fixAgentContent(o: TAgentContent) { }
  static fixSpaceType(o: TSpaceType) {
    o.name_lang = this.lang(o.name_lang);
  }
  static fixSpacePurpose(o: TSpacePurpose) {
    o.name_lang = this.lang(o.name_lang);
  }

  static fixSpaceFacility(o: TSpaceFacility) {
    o.name_lang = this.lang(o.name_lang);
  }
  static fixEvent(o: TEvent) {
    o.startTime = date_utils.toMomentLocal(o.startTime);
    o.endTime = date_utils.toMomentLocal(o.endTime);
  }
  static fixUser(o: TUser) {
    o.lastLogin = date_utils.toMomentLocal(o.lastLogin);
  }
  static fixBlacklistRecord(o: TMemberBlacklistRecord) {
    o.date = date_utils.toMomentLocal(o.date);
  }
  static fixOrganization(o: TOrganization) {
    o.name_lang = this.lang(o.name_lang);
  }
  static fixBooking(o: TBooking) {
    if (o.checkin) {
      this.fixCheckinLog(o.checkin);
    }
    if (o.checkinLogs) {
      for (let oo of o.checkinLogs) {
        this.fixCheckinLog(oo);
      }
    }

    if (o.facilityInfo && typeof o.facilityInfo == 'string') {
      o.facilityInfo = JSON.parse(o.facilityInfo);
    } else {
      o.facilityInfo = [];
    }
    o.date = date_utils.toMomentLocal(o.date);
    o.startTime = date_utils.toMomentLocal(o.startTime);
    o.endTime = date_utils.toMomentLocal(o.endTime);
    o.cancelDate = date_utils.toMomentLocal(o.cancelDate);
    o.rejectDate = date_utils.toMomentLocal(o.rejectDate);
    o.approveDate = date_utils.toMomentLocal(o.approveDate);

    o.durationMins = 0;
    if (o.space) {
      this.fixSpace(o.space as any);
    }
    if (o.locker) {
      this.fixLocker(o.space as any);
    }
    if (o.purpose) {
      this.fixSpacePurpose(o.purpose);
    }
    if (o.startTime && o.endTime) {
      o.durationMins = o.endTime.diff(o.startTime, 'minutes');
    }
    o.facilities = o.facilities ?? [];
    for (let f of o.facilities) {
      this.fixSpaceFacility(f);
    }
    for (let oo of o.facilityInfo) {
      let p = o.facilities.find((c) => c.id == oo.id);
      if (p) {
        Object.assign(p, oo);
      }
    }

    if (o.startTime && o.endTime) {
      let start = TimeAtom.fromMoment(o.startTime);
      let end = TimeAtom.fromMoment(o.endTime);
      o.schedule = new DaySchedule();
      o.schedule.slots.push(new DaySlot({ start, end }));
    }
    o.participants = o.participants ?? [];
    for (let oo of o.participants) {
      oo.date = date_utils.toMomentLocal(oo.date)

    }
  }
  static fixDevice(o: TDevice) { }
  static fixAgent(o: TAgent) { }
  static fixAccessLog(o: TAccessLog) {
    o.time = date_utils.toMomentLocal(o.time);
  }
  static fixCheckinLog(o: TCheckinLog) {
    o.time = date_utils.toMomentLocal(o.time);
  }
}
